<div class="assignment-positions">
  <div class="content">
    <div class="assignment-section">
      <dx-data-grid
        id="positions-grid"
        [dataSource]="positions()"
        keyExpr="ArticleNo"
        [showRowLines]="true"
        [showColumnLines]="false"
        [showBorders]="false"
        [allowColumnReordering]="false"
        [allowColumnResizing]="true"
        style="width: 100%">
        <dxo-paging [pageSize]="120"></dxo-paging>
        <dxo-scrolling
          mode="infinite"
          [useNative]="false"
          [scrollByContent]="true"
          [scrollByThumb]="true"
          showScrollbar="onHover">
        </dxo-scrolling>
        <dxi-column
          dataField="OrderQuantity"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.ORDERQUANTITY' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="ReturnedValue"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.RETURNEDVALUE' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="Name"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.NAME' | translate"></dxi-column>
        <dxi-column
          dataField="TotalAmount"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.TOTALAMOUNT' | translate"
          [format]="{ type: 'fixedPoint', precision: 2 }"
          alignment="center">
        </dxi-column>
        <dxi-column
          dataField="ArticleNo"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.ARTICLENO' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="PackagingUnit"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.PACKAGINGUNIT' | translate"
          alignment="center"></dxi-column>
        <dxi-column
          dataField="CrateAmount"
          [allowSorting]="false"
          [caption]="'ASSIGNMENT.POSITION.CRATEAMOUNT' | translate"
          alignment="center"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
